import React from 'react'
import ReactDOM from 'react-dom'
import Pimper from './node_modules/components/Pimper'

function insertRecommendation(divName) {
    const validQueryParams = [
        "lurker_id",
        "list_id",
        "test_id",
        "platform",
        "object_name",
        "custom_tag",
        "category_id",
        "subcategory_id",
        "region_id",
        "state_id",
        "keyword_search",
        "ad_price",
        "sd_id",
        "zone_id",
        "orientation",
        "component",
        "shouldFacelift"
      ]

    let params = {}
    validQueryParams.forEach( param => {
        const value = divName.getAttribute(param)
        if(value) {
            params[param] = value
        }
    })

    ReactDOM.render(
        <Pimper
            {...params}
        />,
        divName
    )
}

let recommendationDivs = Array.from(document.getElementsByClassName('recommendation'))
recommendationDivs.map(insertRecommendation)




// WEBPACK FOOTER //
// ./src/index.js